import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Tag,
  Form,
  Space,
  Tooltip,
  Modal,
  Empty,
  Radio,
  Input,
} from "antd";
import { EditOutlined, FileProtectOutlined, InfoCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
import { LoadSkeleton } from "../../../components/skeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFaceFrown, faFaceLaugh, faFaceMeh, faFaceSmile } from "@fortawesome/free-regular-svg-icons";
const { Text } = Typography;

const array_options = [
  { icon: faFaceFrown, description: "Competência não desenvolvida", value: 1 },
  { icon: faFaceMeh, description: "Competência em desenvolvimento", value: 2 },
  { icon: faFaceSmile, description: "Competência desenvolvida e aplicada dentro da expectativa", value: 3 },
  {
    icon: faFaceLaugh,
    description: "Competência plenamente desenvolvida e aplicada superando as expectativas",
    value: 4,
  },
];

export const AvaliacoesLancamento = () => {
  const [form] = Form.useForm();
  const { id_formulario_lancamento } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState({});
  const [modal, contextHolder] = Modal.useModal();
  const questoes = Form.useWatch("questoes", form);

  useEffect(() => {
    if (id_formulario_lancamento) {
      carregarFormularioLancamento(id_formulario_lancamento);
    }
  }, [id_formulario_lancamento]);

  // CARREGAR FORMULÁRIO
  const carregarFormularioLancamento = async (id) => {
    setLoading(true);
    const api = await http("get", `v1/avaliacoes_formularios_lancamento/carregar/${id}`, []);
    if (api.statusCode === 200) {
      setDados(api?.response?.data);
    } else {
      message.error(api.response.message);
      navigate("/avaliacoes");
    }
    setLoading(false);
  };

  // ENVIAR LANÇAMENTO
  const enviarFormularioLancamento = async (formulario) => {
    if (!formulario.id_avaliacoes_formulario_lancamento) return;
    setLoading(true);
    const api = await http("post", `v1/avaliacoes_questoes_lancamento/adicionar`, formulario);
    if (api.statusCode === 200) {
      message.success("Formulário enviado com sucesso!");
      navigate("/avaliacoes");
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // ENVIAR FORMULÁRIO
  const onSubmit = (formulario) => {
    formulario.id_avaliacoes_formulario_lancamento = id_formulario_lancamento;
    enviarFormularioLancamento(formulario);
  };

  if (loading) return <LoadSkeleton />;

  // VAZIO
  const renderEmpty = () => {
    return (
      <div className="center">
        <Empty />
      </div>
    );
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      {contextHolder}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Avaliações" onClickBack={() => navigate("/avaliacoes")} />
            <HeaderTitle
              title="Realizar Avaliação"
              subtitle={
                <Text italic>
                  <FileProtectOutlined /> <Tag>{dados?.avaliacao ?? ""}</Tag>
                  {dados?.colaborador ?? ""}
                </Text>
              }
              icon={<EditOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              {loading ? (
                renderEmpty()
              ) : (
                <Space direction="vertical">
                  <Row>
                    <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12} style={{ marginBottom: 20 }}>
                      <Space direction="vertical" size={0}>
                        <Text type="secondary" style={{ fontSize: 14 }}>
                          Avaliação
                        </Text>
                        <Text strong style={{ fontSize: 16 }}>
                          {dados?.avaliacao}
                        </Text>
                      </Space>
                    </Col>
                    <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12} style={{ marginBottom: 20 }}>
                      <Space direction="vertical" size={0}>
                        <Text type="secondary" style={{ fontSize: 14 }}>
                          Colaborador Avaliado
                        </Text>
                        <Text strong style={{ fontSize: 16 }}>
                          {dados?.colaborador}
                        </Text>
                      </Space>
                    </Col>
                    <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
                      <Space direction="vertical" size={0}>
                        <Text type="secondary" style={{ fontSize: 14 }}>
                          Formulário
                        </Text>
                        <Text strong style={{ fontSize: 16 }}>
                          {dados?.formulario}
                        </Text>
                      </Space>
                    </Col>
                  </Row>

                  <Divider />
                  <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off" scrollToFirstError>
                    {dados?.grupos?.map((grupo) => (
                      <React.Fragment key={grupo.id}>
                        <Text strong style={{ fontSize: 16 }}>
                          {grupo?.descricao}
                        </Text>
                        <Row style={{ paddingLeft: 10 }}>
                          {grupo?.questoes?.map((questao) =>
                            questao?.tipo === 2 ? (
                              <FormItemDescritiva
                                key={questao.id}
                                id={questao.id}
                                dica={questao?.dica}
                                descricao={questao?.descricao}
                                resposta={questao?.resposta_descritiva}
                                status={dados?.status}
                                loading={loading}
                              />
                            ) : (
                              <FormItemObjetiva
                                key={questao.id}
                                id={questao.id}
                                dica={questao?.dica}
                                descricao={questao?.descricao}
                                resposta={questoes?.[`${questao?.id}`]?.alt ?? questao?.resposta}
                                status={dados?.status}
                                loading={loading}
                                obs={questao?.obs}
                              />
                            )
                          )}
                        </Row>
                      </React.Fragment>
                    ))}

                    {dados?.status === 0 && (
                      <Button
                        type="primary"
                        size="large"
                        icon={<CheckCircleOutlined />}
                        loading={loading}
                        onClick={() =>
                          modal.confirm({
                            title: "Deseja enviar o formulário?",
                            okText: "Sim",
                            cancelText: "Cancelar",
                            onOk() {
                              form.submit();
                            },
                          })
                        }>
                        Finalizar
                      </Button>
                    )}
                  </Form>
                </Space>
              )}
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};

const FormItemObjetiva = React.memo(({ id, descricao, resposta, dica, status, loading, obs }) => {
  return (
    <React.Fragment>
      <Col xs={24} sm={24} md={24} lg={17} xl={17} xxl={17} align="left">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "100%",
          }}>
          <Space>
            <Text>{descricao}</Text>
            <Tooltip title={<div className="line-break">{dica}</div>}>
              <InfoCircleOutlined style={{ fontSize: 18, color: "#60b565", cursor: "pointer" }} />
            </Tooltip>
          </Space>
        </div>
      </Col>
      <Col xs={24} sm={24} md={24} lg={7} xl={7} xxl={7} align="right">
        <Space size={5} direction="vertical">
          <Form.Item
            name={["questoes", `${id}`, "alt"]}
            rules={[{ required: true, message: "Selecione uma opção." }]}
            style={{ margin: 0 }}
            initialValue={resposta}>
            <Radio.Group disabled={status === 1 || loading} value={resposta}>
              {array_options?.map((op) => (
                <Radio style={{ marginBottom: 10 }} value={op?.value} key={op?.value} className="radio-rate">
                  <Tooltip title={op?.description}>
                    <div>
                      <FontAwesomeIcon
                        className={`icon-rate ${resposta === op?.value && "icon-rate-checked"}`}
                        icon={op?.icon}
                      />
                    </div>
                  </Tooltip>
                </Radio>
              ))}
            </Radio.Group>
          </Form.Item>

          {(resposta === 1 || resposta === 2) && (
            <Form.Item
              name={["questoes", `${id}`, "obs"]}
              rules={[{ required: true, message: "Informe o motivo." }]}
              style={{ margin: 0 }}
              initialValue={obs}>
              <Input.TextArea
                autoSize={{ minRows: 3, maxRows: 5 }}
                disabled={status === 1 || loading}
                placeholder="Descreva o motivo da sua resposta"
              />
            </Form.Item>
          )}
        </Space>
      </Col>
      <Divider style={{ marginTop: 5, marginBottom: 6 }} />
    </React.Fragment>
  );
});

const FormItemDescritiva = React.memo(({ id, descricao, resposta, dica, status, loading }) => {
  return (
    <React.Fragment key={id}>
      <Col span={24} style={{ marginBottom: 10 }}>
        <Space>
          <Text>{descricao}</Text>
          <Tooltip title={<div className="line-break">{dica}</div>}>
            <InfoCircleOutlined style={{ fontSize: 18, color: "#60b565", cursor: "pointer" }} />
          </Tooltip>
        </Space>
      </Col>
      <Col span={24}>
        <Space size={5} direction="vertical" style={{ width: "100%" }}>
          <Form.Item
            name={["questoes_desc", `${id}`, "desc"]}
            rules={[{ required: true, message: "Informe a resposta" }]}
            style={{ margin: 0 }}
            initialValue={resposta}>
            <Input.TextArea
              style={{ maxWidth: 600 }}
              autoSize={{ minRows: 2, maxRows: 3 }}
              disabled={status === 1 || loading}
              size="large"
              placeholder="Informe a resposta"
            />
          </Form.Item>
        </Space>
      </Col>
      <Divider style={{ marginTop: 5, marginBottom: 6 }} />
    </React.Fragment>
  );
});
